export interface IResponse {
    lastUpdated: string;
    tutorials: ITutorial[];
    version: string;
}

export type ICustomText = Array<{
    locale?: string; // theme
    value?: string;
}>;

export type ICustomMedia = Array<{
    locale?: string; // language
    value?: Array<{
        key: string; // theme
        value: string;
    }>;
}>;

export interface ISlide {
    media: string;
    mediaCustom?: ICustomMedia;
    title: string;
    titleCustom?: ICustomText;
    description: string;
    descriptionCustom?: ICustomText;
}

export enum ActionEnum {
    Done = 'done',
    Load = 'load',
    PaymentSuccess = 'payment_success',
    Unload = 'unload',
    View = 'view',
    Skip = 'skip',
}

export interface ITutorialCriteria {
    actionTypes?: ActionEnum[];
    active?: boolean;
    pathnames?: string[];
}

export enum ApplicationEnum {
    CustomerApp = 'customer_app',
    VendorPanel = 'vendor_panel',
}

export interface ITutorial {
    namespace: string;
    id: string;
    application: ApplicationEnum;
    priority: number;
    content: ISlide[];
    criteria?: ITutorialCriteria;
    created_at: string;
    updated_at: string;
}
